export const getKnoOrganizationFunctionsGroupStoreKey = (knoOrganizationId: string) => knoOrganizationId;
